import React, { useState, useEffect } from "react";
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import CountUp from "react-countup";
import { RevenueCharts } from "./DashboardEcommerceCharts";
import api,{ handleApiError }  from "../../helpers/api";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

const Revenue = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [revenueData, setRevenueData] = useState({
    orders: 0,
    earnings: 0,
    cancelledOrders: 0,
    conversionRatio: 0,
    chartData: { labels: [], series: [] },
  });
  const [period, setPeriod] = useState("month");

  const fetchRevenueData = async (periodType) => {
    try {
      const res = await api.get(`/dashboard/revenue?period=${periodType}`);
      setRevenueData(res.data);
    } catch (err) {
      handleApiError(err, dispatch, navigate);
    }
  };

  useEffect(() => {
    fetchRevenueData(period);
  }, [period, dispatch, navigate]);

  const onChangeChartPeriod = (pType) => {
    setPeriod(pType);
  };

  return (
      <React.Fragment>
        <Card>
          <CardHeader className="border-0 align-items-center d-flex">
            <h4 className="card-title mb-0 flex-grow-1">Revenue</h4>
            <div className="d-flex gap-1">
              <button
                  type="button"
                  className={`btn btn-soft-${period === "all" ? "primary" : "secondary"} btn-sm`}
                  onClick={() => onChangeChartPeriod("all")}
              >
                ALL
              </button>
              <button
                  type="button"
                  className={`btn btn-soft-${period === "month" ? "primary" : "secondary"} btn-sm`}
                  onClick={() => onChangeChartPeriod("month")}
              >
                1M
              </button>
              <button
                  type="button"
                  className={`btn btn-soft-${period === "halfyear" ? "primary" : "secondary"} btn-sm`}
                  onClick={() => onChangeChartPeriod("halfyear")}
              >
                6M
              </button>
              <button
                  type="button"
                  className={`btn btn-soft-${period === "year" ? "primary" : "secondary"} btn-sm`}
                  onClick={() => onChangeChartPeriod("year")}
              >
                1Y
              </button>
            </div>
          </CardHeader>

          <CardHeader className="p-0 border-0 bg-soft-light">
            <Row className="g-0 text-center">
              <Col xs={6} sm={3}>
                <div className="p-3 border border-dashed border-start-0">
                  <h5 className="mb-1">
                    <CountUp start={0} end={revenueData.orders} duration={3} separator="," />
                  </h5>
                  <p className="text-muted mb-0">Orders</p>
                </div>
              </Col>
              <Col xs={6} sm={3}>
                <div className="p-3 border border-dashed border-start-0">
                  <h5 className="mb-1">
                    <CountUp
                        prefix="DT "
                        start={0}
                        end={revenueData.earnings}
                        decimals={2}
                        duration={3}
                    />
                  </h5>
                  <p className="text-muted mb-0">Earnings</p>
                </div>
              </Col>
              <Col xs={6} sm={3}>
                <div className="p-3 border border-dashed border-start-0">
                  <h5 className="mb-1">
                    <CountUp start={0} end={revenueData.cancelledOrders} duration={3} />
                  </h5>
                  <p className="text-muted mb-0">Cancelled Orders</p>
                </div>
              </Col>
              <Col xs={6} sm={3}>
                <div className="p-3 border border-dashed border-start-0 border-end-0">
                  <h5 className="mb-1 text-success">
                    <CountUp
                        start={0}
                        end={revenueData.conversionRatio}
                        decimals={2}
                        duration={3}
                        suffix="%"
                    />
                  </h5>
                  <p className="text-muted mb-0">Conversion Ratio</p>
                </div>
              </Col>
            </Row>
          </CardHeader>

          <CardBody className="p-0 pb-2">
            <div className="w-100">
              <div dir="ltr">
                <RevenueCharts
                    dataColors='["--vz-success", "--vz-primary"]'
                    series={revenueData.chartData.series}
                    categories={revenueData.chartData.labels}
                    options={{
                      xaxis: {
                        title: {
                          text: period === "month" ? "Date" : period === "all" ? "Year" : "Month",
                        },
                      },
                    }}
                />
              </div>
            </div>
          </CardBody>
        </Card>
      </React.Fragment>
  );
};

export default Revenue;